export enum Routes {
  ThankYouPage = '/thank-you',
  Base = '/pre-screen',
  MessagePage = '/message',
}
